import { style } from '@vanilla-extract/css';
import { vars } from '../../theme/contract.css';

// 로딩 자리는 움직이지 않는다 — 옅은 면만 그린다.
export const base = style({
  position: 'relative',
  overflow: 'hidden',
  background: vars.surface.highlight.light,
  borderRadius: '4px',
  opacity: 0.5,
});

export const line = style([
  base,
  {
    height: '12px',
    width: '100%',
  },
]);

export const block = style([
  base,
  {
    height: '48px',
    width: '100%',
  },
]);

export const windowSkeleton = style({
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  /*
   * 면은 여기가 진다. 이 한 줄이 없으면 창 로딩이 아무것도 안 그려서 "창이 깨졌다"와
   * 구별되지 않는다 — 실제로 팀 운영 창을 두고 그 오해가 났다.
   */
  background: vars.surface.highlight.light,
});

// 자리 표시 아래 불러오는 중 문장 — 움직임이 없어도 글자로 상태를 알린다.
export const caption = style({
  margin: 0,
  fontSize: vars.typography.fontSize.sm,
  color: vars.typography.textColor.secondary,
});
